<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "SubscriptionForm" });
import { Form } from "../../../../components/index.js";
import { onChange, merge } from "../../../../common/store.js";
import { createEventDispatcher, onMount } from "svelte";
import { writable } from "svelte/store";
import * as API from "../../services/api.js";
const DEFAULT = {
    channels: [],
    constraints: {
        brandKeys: [],
        categoryKeys: [],
        genderCodes: [],
        gradeCodes: [],
        minimum: {},
        typeCodes: [],
        verticalCode: "fashion-and-accessories"
    },
    interval: "immediate",
    ownerKey: ""
};
let FormElement = null;
const dispatch = createEventDispatcher();
export let subscription = {};
export let action = "create";
export let beforeSave = () => {
};
export let align = "vertical";
export const DATA = writable(DEFAULT);
export const submit = async () => {
    if (FormElement === null) {
        return;
    }
    await FormElement.submit();
};
export const subscribe = onChange.bind(null, DATA);
export const reset = (subscription2) => {
    DATA.set(merge([DEFAULT, subscription2]));
};
export let onError = void 0;
const onSave = (response) => {
    if (response !== null && "code" in response) {
        return;
    }
    dispatch("save", response);
};
const update = async ({ _: { key }, ...data }) => {
    onSave(await API.updateSubscription({ subscriptionKey: key }, data, onError));
};
const create = async (data) => {
    onSave(await API.createSubscription(data, onError));
};
const onSubmit = async () => {
    await beforeSave();
    if (action === "update") {
        await update($DATA);
        return;
    }
    await create($DATA);
};
onMount(() => {
    if ("_" in subscription && action === "create") {
        delete subscription._;
    }
    DATA.set(merge([$DATA, subscription]));
});
export const isValid = () => {
    if (FormElement === null) {
        return false;
    }
    return FormElement.isValid();
};
</script>

<Form { onSubmit } id = { `${ action }-subscription` } bind:this = { FormElement } { align }>
    <slot>
        <h3>{ action } Subscription</h3>
        <pre>{ JSON.stringify(subscription, null, 2) }</pre>
    </slot>

    <svelte:fragment slot = 'footer'><slot name = 'footer' /></svelte:fragment>
</Form>